import { Client } from "../@data";

const CLIENT_STORAGE_KEY = "thebest_client_data";

export const saveClientToLocalStorage = (client: Client) => {
  try {
    localStorage.setItem(CLIENT_STORAGE_KEY, JSON.stringify(client));
  } catch (error) {
    console.error("Erro ao salvar cliente no localStorage:", error);
  }
};

export const getClientFromLocalStorage = (): Client | null => {
  try {
    const clientData = localStorage.getItem(CLIENT_STORAGE_KEY);
    if (clientData) {
      return JSON.parse(clientData) as Client;
    }
    return null;
  } catch (error) {
    console.error("Erro ao recuperar cliente do localStorage:", error);
    return null;
  }
};

export const clearClientFromLocalStorage = () => {
  try {
    localStorage.removeItem(CLIENT_STORAGE_KEY);
  } catch (error) {
    console.error("Erro ao limpar cliente do localStorage:", error);
  }
};
